import React from 'react';
import { Button } from '@mui/material';
import { useStacklineTheme } from '@stackline/ui';

interface RuleButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

const RuleButton: React.FC<RuleButtonProps> = ({ children, onClick, disabled = false }) => {
  const theme = useStacklineTheme();

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: theme.colors.white,
        color: theme.colors.primary,
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 400,
        borderRadius: '8px',
        border: `1px solid ${theme.colors.primaryGray}`,
        '&:hover': {
          backgroundColor: '#f9f9f9',
          borderColor: '#cccccc'
        },
        '&.Mui-disabled': {
          opacity: 0.5,
          color: theme.colors.primaryGray,
          borderColor: theme.colors.primaryGray
        }
      }}
    >
      {children}
    </Button>
  );
};

export default RuleButton;
